"use client"

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline"
import { ThingWithId } from "../../seo/types"
import { DarkText } from "@ui/text"

const faqs = [
    {
        question: "Where does my data go?",
        answer: "No where! All the processing happens in your browser; the data is never sent over the Internet.",
    },
    {
        question: "What types of personal information does the PII Scanner recognize?",
        answer: "Currently, it recognizes the following types of personal information: email addresses, phone numbers, IP addresses, credit card numbers, and people's names.",
    },
    {
        question: "How long does it take to process my data?",
        answer: "The processing time depends on the size of your datafile. It usually takes a few seconds to a few minutes.",
    },
    {
        question: "How do I download the cleaned data file?",
        answer: "Once the processing is complete, you will see a download button. Click on it to download the cleaned data file.",
    },
    {
        question: "What file formats does the PII Scanner accept?",
        answer: "The PII Scanner accepts data files in CSV, TXT, TSV, XLS, and XLSX formats.",
    },
    {
        question: "Is the PII Scanner free to use?",
        answer: "Yes, the PII Scanner is free to use.",
    },
    {
        question: "How do you use my data?",
        answer: "None of the data you upload to the PII Scanner is stored or used by ResearchWiseAI. We do not have access to your data.",
    },
    {
        question: "What is the PII Scanner?",
        answer: "The PII Scanner is a tool that helps you identify and remove personal information from your survey data.",
    },
    {
        question: "How do I know if my data is safe?",
        answer: "All the processing happens in your browser; the data is never sent over the Internet. It is not even stored in your browser after you have finished.",
    },
    {
        question: "Can I use the PII Scanner for commercial purposes?",
        answer: "Yes, you can use the PII Scanner for commercial purposes.",
    },
    {
        question: "What is personal information?",
        answer: "Personal information is any information that can be used to identify an individual. This includes, but is not limited to, email addresses, phone numbers, IP addresses, and credit card numbers.",
    },
    {
        question: "How do I contact support?",
        answer: "If you have any questions or need help, please contact us at support@researchwiseai.com.",
    },
]

export const structuredData: ThingWithId = {
    "@type": "FAQPage",
    "@id": "https://researchwiseai.com/pii-scanner#faq",
    mainEntity: faqs.flat().map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
        },
    })),
}

export function PiiFAQs() {
    return (
        <div className="mb-8">
            <div className="mx-auto divide-y divide-gray-900/10 dark:divide-gray-700">
                <h2 className="mb-4 text-lg font-semibold">Frequently asked questions</h2>
                <dl className="mt-10 space-y-6 divide-y divide-gray-900/10 dark:divide-gray-700">
                    {faqs.map((faq) => (
                        <Disclosure key={faq.question} as="div" className="pt-6">
                            <dt>
                                <DisclosureButton className="group flex w-full cursor-pointer items-start justify-between text-left text-gray-900 dark:text-gray-300">
                                    <span className="text-base/7 font-semibold">{faq.question}</span>
                                    <span className="ml-6 flex h-7 items-center">
                                        <PlusSmallIcon aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                                        <MinusSmallIcon
                                            aria-hidden="true"
                                            className="size-6 group-[&:not([data-open])]:hidden"
                                        />
                                    </span>
                                </DisclosureButton>
                            </dt>
                            <DisclosurePanel as="dd" className="mt-2 pr-12">
                                <DarkText className="text-base/7">{faq.answer}</DarkText>
                            </DisclosurePanel>
                        </Disclosure>
                    ))}
                </dl>
            </div>
        </div>
    )
}
